import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getLegalDocument } from "../../api/legalApi";
import SafeMarkdownContent, { isDraftLegalContent } from "../../utils/safeMarkdown";
import { documentTypeFromPublicPath } from "../../utils/legalRoutes";

const LegalDocumentPage = () => {
  const documentType = documentTypeFromPublicPath(window.location.pathname);
  const [document, setDocument] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!documentType) {
      setErrorMessage("Unknown legal document.");
      setIsLoading(false);
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        setIsLoading(true);
        const body = await getLegalDocument(documentType);
        if (!cancelled) {
          setDocument(body.document);
        }
      } catch (error) {
        if (!cancelled) {
          setErrorMessage(error.message || "Unable to load document.");
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [documentType]);

  return (
    <div className="midpoint-app auth-page">
      <section className="panel-card legal-document-page">
        <p className="eyebrow">Legal</p>
        {isLoading ? <p className="muted">Loading…</p> : null}
        {errorMessage ? <p className="admin-data-health-error">{errorMessage}</p> : null}
        {document ? (
          <>
            <h1>{document.title}</h1>
            <p className="muted">
              Version {document.version} · Effective{" "}
              {new Date(document.effectiveAt).toLocaleDateString()}
            </p>
            {isDraftLegalContent(document.contentMarkdown) ? (
              <p className="admin-data-health-error">
                Draft placeholder. Replace with reviewed legal copy before production launch.
              </p>
            ) : null}
            {document.summary ? <p className="muted">{document.summary}</p> : null}
            <SafeMarkdownContent markdown={document.contentMarkdown} />
          </>
        ) : null}
        <p className="muted legal-document-page__footer">
          <Link to="/">Back to map</Link>
          {" · "}
          <Link to="/login">Sign in</Link>
        </p>
      </section>
    </div>
  );
};

export default LegalDocumentPage;
